import axios from "axios";
import React from "react";
import styles from "./chat.module.css";
import moment from 'jalali-moment'
const Message = ({message , own }) => {
  return (
    <div className={own ? styles.messageOwn : styles.messageOther}>
      <span className={styles.chatText}>{message.message}</span>
      <span className={styles.chatTime}>{moment(message.created_at).format('H:mm')}</span>
    </div>
  );
};

export default Message;
